<lcs-loading-overlay [show]="callState | lcsCallState : 'loading'">
   <div mat-dialog-title class="dialog-header">
      <h3 class="dialog-title">{{ title }}</h3>
      <button type="button" mat-icon-button tabindex="-1" (click)="onCloseClick()"><mat-icon>close</mat-icon></button>
   </div>
   <form [formGroup]="form" (ngSubmit)="onCreate()">
      <mat-dialog-content>
         <div class="advanced-dialog-content">
            <mat-checkbox class="flex-full" [checked]="account?.isResidential" formControlName="isResidential"
               >Residential</mat-checkbox
            >
            <mat-checkbox class="flex-full" [checked]="account?.isSuspended" formControlName="isSuspended"
               >Suspended</mat-checkbox
            >
            <mat-checkbox
               class="flex-full"
               [checked]="account?.isLcsInternal"
               formControlName="isLcsInternal"
               id="465fa5a0-f8b4-4e52-a839-60e7766ff112"
            >
               LCS Internal
            </mat-checkbox>
         </div>
      </mat-dialog-content>
      <mat-dialog-actions>
         <button type="submit" title="Confirm" mat-raised-button>OK</button>
         <button type="button" title="Cancel" mat-stroked-button (click)="onCloseClick()">Cancel</button>
      </mat-dialog-actions>
   </form>
</lcs-loading-overlay>
